import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import { setActiveFilterId } from 'actions/todos';

const FilterLabel = styled.label`
  font-family: Averta, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Helvetica Neue, Arial, sans-serif;
  font-weight: 600;
  background-color: var(--cc_color_background_1);
  border: var(--cc_size_border_width_s) solid var(--cc_color_border_default);
  color: var(--cc_color_text_subtle);
  border-radius: 100px;
  display: inline-block;
  font-size: var(--cc_size_text_s);
  margin: 0;
  margin-right: var(--cc_size_spacing_s);
  padding: 10px 14px 11px;
  cursor: pointer;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FilterInput = styled.input`
  opacity: 0;
  position: fixed;
  width: 0;

  &:checked + label {
    background-color: var(--cc_color_button_background_secondary);
    color: white;
  }

  &:not(:checked) + label:hover,
  &:not(:checked) + label:focus,
    background-color: var(-cc_color_button_background_subtle)
;`;

const FiltersForm = styled.div`
  overflow-x: scroll;
  display: flex;
  width: 100%;
  padding: var(--cc_size_spacing_l) var(--cc_size_spacing_l)
    var(--cc_size_spacing_m) var(--cc_size_spacing_l);
  white-space: nowrap;
`;

const SearchFilters = ({ filters }) => {
  const dispatch = useDispatch();
  const activeFilterId = useSelector(
    (state) => state.todos.templates.activeFilterId,
  );
  return (
    <FiltersForm>
      {filters.map(({ id, label }) => (
        <div key={id}>
          <FilterInput
            data-testid="search-filters-input"
            id={`${id}-${label}`}
            checked={activeFilterId === id}
            name="search-filter"
            onChange={() => dispatch(setActiveFilterId(id))}
            type="radio"
          />
          <FilterLabel htmlFor={`${id}-${label}`}>{label}</FilterLabel>
        </div>
      ))}
    </FiltersForm>
  );
};

SearchFilters.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default SearchFilters;
